import React, { memo } from 'react';
import { Col, DatePicker, Form, FormModal, Row, Select, Upload } from 'components';
import { UploadContent } from 'components/common';
import { CalendarIcon } from 'components/common/icons';
import { ValidationErrors } from 'constants/validations';
import { useAddEdit } from './useAddEdit';
import moment from 'moment';

const { Dragger } = Upload;

interface IAddModal {
  openModal: boolean;
  onModalStateChange: () => void;
}

const ACCEPTED_FORMATS = ['text/csv', 'application/pdf'];

export const AddPriceListModal = memo((props: IAddModal) => {
  const { openModal, onModalStateChange } = props;
  const { contextHolder, form, handleSubmit, isLoading, handleFileSizeValidation, isSaveBtnDisabled, data } =
    useAddEdit({
      onCancel: onModalStateChange,
    });

  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        width={400}
        title={`Add Pricelist`}
        okText={'Add'}
        disableOkBtn={isSaveBtnDisabled}
        open={openModal}
        isLoading={isLoading}
        onCancel={() => {
          form.resetFields();
          onModalStateChange();
        }}
        onSubmit={handleSubmit}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="priselist"
              label="Priselist*"
              valuePropName="fileList"
              rules={[
                {
                  required: true,
                  validator: (_, value) => {
                    if (value && value.length > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Please upload a file.'));
                  },
                },
              ]}
              getValueFromEvent={(e) => e?.fileList}
            >
              <Dragger
                fileList={form.getFieldValue('priselist')}
                beforeUpload={handleFileSizeValidation}
                accept={ACCEPTED_FORMATS.join(',')}
                maxCount={1}
              >
                <UploadContent title={'Upload FIle'} message={'Max size: 5MB / Format: CSV, PDF'} />
              </Dragger>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={`Brand*`}
              name={'brandIds'}
              rules={[{ required: true, message: ValidationErrors.required('Brand') }]}
            >
              <Select mode={'multiple'} size={'large'} options={data} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={`Expiry Date*`}
              name={'expiryDate'}
              rules={[{ required: true, message: ValidationErrors.required('Expiry Date') }]}
            >
              <DatePicker
                disabledDate={(current) => current && current < moment().startOf('day')}
                size={'large'}
                style={{ width: '100%' }}
                suffixIcon={<CalendarIcon />}
              />
            </Form.Item>
          </Col>
        </Row>
      </FormModal>
    </>
  );
});
